/* eslint-disable react-hooks/refs */
import React, { useContext, useRef } from 'react'
import { Store, WithoutFunctions } from './type'
import { createPBStore } from '.'
import { useStore } from 'zustand'

type PostBookProviderProps = React.PropsWithChildren<
  Partial<WithoutFunctions<Store>>
>
type PostBookStore = ReturnType<typeof createPBStore>

const PostBookContext = React.createContext<PostBookStore | null>(null)

export function PostBookStoreProvider({
  children,
  ...props
}: PostBookProviderProps): JSX.Element {
  const storeRef = useRef<PostBookStore | null>()
  if (!storeRef.current) {
    storeRef.current = createPBStore(props)
  }
  return (
    <PostBookContext.Provider value={storeRef.current}>
      {children}
    </PostBookContext.Provider>
  )
}

export function usePBStore<T>(selector: (store: Store) => T): T {
  const store = useContext(PostBookContext)
  if (!store) throw new Error('Missing PostBookStoreProvider in the tree')
  return useStore(store, selector)
}
